import { PrimaryButton, ReactIcons } from "@kalyzee/kalyzee-ui";
import React from "react";

import styles from "./SimpleButton.module.css";
import clsx from "clsx";

interface SimpleButtonProps {
  label: string;
  onClick: () => void | Promise<void>;
  className?: string;
  style?: React.CSSProperties;
}

const SimpleButton: React.FC<SimpleButtonProps> = ({
  label,
  onClick,
  className,
  style,
}) => {
  return (
    <PrimaryButton
      onClick={onClick}
      style={style}
      className={clsx(styles.container, className)}
      renderContent={(loading) => (
        <>
          {label}
          {loading && <ReactIcons.Spinner className={styles.spinner} />}
        </>
      )}
    />
  );
};

export default SimpleButton;